module.exports = __webpack_public_path__ + "img/logo.d6ba1977.svg";